module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-detail"
  }, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      key: product.id,
      staticClass: "order-row"
    }, [_c('div', {
      staticClass: "order-col order-name"
    }, [_c('span', {
      staticClass: "order-index",
      style: (("color:" + (_vm.globalColors.primary)))
    }, [_vm._v(_vm._s(index + 1) + "-")]), _vm._v(" " + _vm._s(product.productName) + "\n\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "order-col"
    }, [_vm._v("\n\t\t\tCantidad: " + _vm._s(product.quantity) + "\n\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "order-col order-amount"
    }, [_vm._v("\n\t\t\t" + _vm._s(product.currencySymbol) + " " + _vm._s(product.total) + "\n\t\t")])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d75bfa0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/order-detail.vue
// module id = 1074
// module chunks = 2